import React from "react";

export default function About() {
  return (
    <div style={{ 
      backgroundColor: "#FFFFFF", 
      color: "#1E2A38", 
      padding: "2rem", 
      fontFamily: "Arial, sans-serif",
      textAlign: "center" 
    }}>
      <h1 style={{ color: "#4A7C59" }}>About Benjamin</h1>
      <p style={{ maxWidth: "600px", margin: "0 auto", lineHeight: "1.6" }}>
        Benjamin is a certified results coach helping individuals align with their goals, 
        build actionable plans, and move forward with confidence. He uses the RAPID results 
        model and deeply values client empowerment and listening.
      </p>
      <img 
        src="/ben.jpg" 
        alt="Benjamin Hoch" 
        style={{ 
          width: "300px", 
          borderRadius: "8px", 
          marginTop: "2rem", 
          display: "block", 
          marginLeft: "auto", 
          marginRight: "auto", 
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" 
        }} 
      />
    </div>
  );
}
